<!-- Inspection Charges Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Inspection Charges Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-inspection-charge-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-light-primary me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>

        <!-- Add Inspection Charge Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddInspectionChargeModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Inspection Charge
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-inspection-charge-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span data-kt-inspection-charge-table-select="selected_count">{{ selectedInspectionCharges.length }}</span> Selected
        </div>
        <button type="button" class="btn btn-danger" (click)="deleteSelectedInspectionCharges()" data-kt-inspection-charge-table-select="delete_selected">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Filters Form -->
    <div *ngIf="showFiltersForm" [@slideInOut] class="mb-10">
      <div class="card bg-light-primary">
        <div class="card-body">
          <div class="row">
            <!-- Search Input -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Search</label>
              <input
                type="text"
                class="form-control form-control-solid"
                [(ngModel)]="searchTerm"
                placeholder="Search inspection charges..."
                (keyup.enter)="applyFilters()"
              />
            </div>
          </div>

          <!-- Filter Actions -->
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-sm btn-secondary me-3" (click)="resetFilters()">
              Reset
            </button>
            <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>



    <!-- Data Table -->
    <div *ngIf="!isLoading" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_inspection_charges_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-25px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-200px">Name</th>
            <th class="min-w-125px">Charge</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let inspectionCharge of inspectionCharges; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="inspectionCharge._id"
                  [checked]="isSelected(inspectionCharge._id)"
                  (change)="toggleSelection(inspectionCharge._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ inspectionCharge.name || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold">{{ inspectionCharge.charge || 0 | currency:'JPY':'symbol':'1.0-0' }}</span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(inspectionCharge)"
                  title="Edit Inspection Charge">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteInspectionCharge(inspectionCharge)"
                  title="Delete Inspection Charge">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
          <!-- Empty State -->
          <tr *ngIf="inspectionCharges.length === 0">
            <td colspan="4" class="text-center py-10">
              <div class="d-flex flex-column align-items-center">
                <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-muted fs-6">No inspection charges found</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && inspectionCharges.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Inspection Charge Add/Edit Modal -->
<app-add-edit-inspection-charges
  (inspectionChargeAdded)="onInspectionChargeAdded()"
  [type]="type"
  (inspectionChargeUpdated)="onInspectionChargeUpdated()">
</app-add-edit-inspection-charges>
